import { render, staticRenderFns } from "./addInstalledVolume.vue?vue&type=template&id=1295a8bc&"
import script from "./addInstalledVolume.vue?vue&type=script&lang=js&"
export * from "./addInstalledVolume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1295a8bc')) {
      api.createRecord('1295a8bc', component.options)
    } else {
      api.reload('1295a8bc', component.options)
    }
    module.hot.accept("./addInstalledVolume.vue?vue&type=template&id=1295a8bc&", function () {
      api.rerender('1295a8bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/components/addInstalledVolume.vue"
export default component.exports